import { LegacyChecklistRecord } from '@/ui/pages/inspection/LegacyChecklistRecord';
import { isEntityTypeOfResponseEnabled } from '@/ui/helpers/featureHelper';
import { findHeader, findResponseType } from '@/_legacy/store/checklist_builder';
import { ResponsesTypes } from '@/entities/checklist';

export function useEntityTypeOfResponseFirstQuestionMapping() {
  const mapEntityTypeOfResponseFirstQuestion = (inspection: LegacyChecklistRecord) => {
    if (isEntityTypeOfResponseEnabled()) {
      const headerPage = findHeader(inspection.form.items);
      const entityTypeOfResponseQuestion = findResponseType(headerPage, ResponsesTypes.entityItem);

      if (entityTypeOfResponseQuestion) {
        if (!entityTypeOfResponseQuestion.response?.length) {
          inspection.entity_item = null;
          inspection.site = null;
          return;
        }

        const [firstResponse] = entityTypeOfResponseQuestion.response;

        inspection.entity_item = firstResponse;
        inspection.site = firstResponse;
      }
    }
  };

  return {
    mapEntityTypeOfResponseFirstQuestion,
  };
}
